import { IconEmail, IconLocation, IconPhone } from './FooterIcons'

function phoneTel(phone) {
  return String(phone || '').replace(/\s/g, '')
}

export function FooterContactRow({ contact, variant = 'light' }) {
  const { phone, email, address } = contact
  const hasAny = phone || email || address
  if (!hasAny) return null

  return (
    <div className={`footer-contact footer-contact--row footer-contact--${variant}`}>
      {phone ? (
        <a href={`tel:${phoneTel(phone)}`} className="footer-contact__item">
          <IconPhone className="footer-contact__icon" />
          <span>{phone}</span>
        </a>
      ) : null}
      {email ? (
        <a href={`mailto:${email}`} className="footer-contact__item">
          <IconEmail className="footer-contact__icon" />
          <span>{email}</span>
        </a>
      ) : null}
      {address ? (
        <span className="footer-contact__item">
          <IconLocation className="footer-contact__icon" />
          <span>{address}</span>
        </span>
      ) : null}
    </div>
  )
}

export function FooterContactColumn({ contact, variant = 'light' }) {
  const { phone, email, address } = contact
  const hasAny = phone || email || address
  if (!hasAny) return null

  return (
    <div className={`footer-contact footer-contact--column footer-contact--${variant}`}>
      {phone ? (
        <a href={`tel:${phoneTel(phone)}`} className="footer-contact__item">
          <IconPhone className="footer-contact__icon" />
          <span>{phone}</span>
        </a>
      ) : null}
      {email ? (
        <a href={`mailto:${email}`} className="footer-contact__item">
          <IconEmail className="footer-contact__icon" />
          <span>{email}</span>
        </a>
      ) : null}
      {address ? (
        <span className="footer-contact__item">
          <IconLocation className="footer-contact__icon" />
          <span>{address}</span>
        </span>
      ) : null}
    </div>
  )
}
